export class DispatchQVSettingsInput {
    
    //constructor(data: DispatchQVSettingsInput) {

    //}
    
    dispatchId: any;
    readOnlyMode: boolean = false;
    showDetails: boolean = false;
    dispatchHeaderButtons: boolean = false;
    createSalesOrderBtn: boolean = false;
    useCPRefData: boolean = false;
    showAssets: boolean = false;
    showLabor: boolean = false;
    showkudos: boolean = false;
    showPartsUsed: boolean = false;
    showPartsRequested: boolean = true;
}
